import {useMutation} from "@tanstack/react-query";

import {restoreServiceFunctionMutationOptions} from "./restore-service-function.mutation-options";

export function useRestoreServiceFunction() {
  return useMutation(restoreServiceFunctionMutationOptions());
}
